import Link from 'next/link'
import type {Elements, IContentItem} from '@kontent-ai/delivery-sdk'
import {useRouter} from 'next/router'
import {MetaTags} from '@/products/flexible-web-toolkit/components/meta-tags'
import {addLocalePrefix} from '@/utilities/add-locale-prefix'
import type {Block} from '@/services/kontent-ai/types'

export type TagSingleContentItem = IContentItem<{
	title: Elements.TextElement
	tag: Elements.TextElement
	link: Elements.TextElement
	snippetCategoryColorCategoryColor: Elements.CustomElement
}>

export const TagSingleBlock: Block<TagSingleContentItem> = ({block}) => {
	// Custom element – guard with typeof so SonarCloud knows it's a string
	const rawColor = block.elements.snippetCategoryColorCategoryColor
	const color = typeof rawColor === 'string' && rawColor ? rawColor : null
	const singleTagColor = color || 'primary'
	const {locale} = useRouter()

	const metaTagsComponent = (
		<MetaTags
			as="p"
			className="container w-full"
			headerText={block.elements.title}
			tags={[block.elements.tag]}
			titleAboveTags={Boolean(block.elements.title)}
			titleBorder={Boolean(block.elements.title)}
			variant={singleTagColor}
		/>
	)
	if (block.elements.link) {
		return (
			<Link
				href={addLocalePrefix(block.elements.link, locale ?? '')}
				rel="noreferrer"
			>
				{}
				{metaTagsComponent}
			</Link>
		)
	}
	return metaTagsComponent
}
